/**
 * Set timeline pipe height for better looking
 * @param el
 */

function timeline(el) {
	let lastChild = el.querySelector(".timeline-item:last-child");
	let pipe = el.querySelector(".timeline-pipe");
	let itemHeight = returnItemHeight(lastChild);

	lastChild.classList.add("last-timeline-item");
	pipe.style.bottom = itemHeight + "px";

	window.addEventListener("resize", () => {
		setTimeout(() => {

			pipe.style.bottom = returnItemHeight(lastChild) + "px";
		}, 200);
	});
}

function returnItemHeight (child, offset = 15) {
	// const offset = 5;
	return (child.offsetHeight - offset);
}

function initTimelines(el) {

	document.addEventListener("DOMContentLoaded", () => {

		const timelines = document.querySelectorAll(el);
		if (timelines.length > 0) {
			timelines.forEach(function (item, index) {
				timeline(item);
			});
		}

	});
}

// export init function
export default initTimelines;
